import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';
import DialogTitle from '../../components/common/Dialog/DialogTitle';
import BrandingTypeService from '../../services/branding-type.service';

interface DeleteBrandingTypeDialogProps {
  open: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  brandingTypeId: string;
}

const DeleteBrandingTypeDialog: React.FC<DeleteBrandingTypeDialogProps> = ({
  open,
  onClose,
  onSuccess,
  brandingTypeId,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleDelete = useCallback(async () => {
    const { message, error } = await BrandingTypeService.deleteBrandingType(brandingTypeId);
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    } else if (message) {
      enqueueSnackbar(message, { variant: 'success' });
      onSuccess?.();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        className: 'w-4/12',
      }}
    >
      <DialogTitle title="Delete branding type" onClose={onClose} />
      <DialogContent>
        <Typography>
          Are you user you want to delete the branding type? The changes can't be reverted back!!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Cancel
        </Button>
        <Button color="secondary" onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBrandingTypeDialog;
